// Report PDF v2 — the only part in the app bundle: a lazy loader. The engine (pdf-lib + fontkit + bidi-js) lives in
// public/report-pdf.bundle.js and is fetched the first time a report PDF is made (the SW then caches it; its content
// is in the SW build hash, as are the fonts).
import { loadBundle } from '../../notes/rich-loader.js';

export const REPORT_PDF_SRC = '/report-pdf.bundle.js';

// → { blob, colours, warnings, pages }. Throws on failure (the callers toast it).
export async function makeReportPdfBlob(ctx) {
  const api = await loadBundle(REPORT_PDF_SRC, 'HUD_REPORT_PDF');
  return api.makeReportBlob(ctx);
}

// Phase 2 Q3 (D2): the pages of a PDF drawn in-app with pdf.js — its own lazy bundle (+ the same-origin worker).
export const REPORT_VIEW_SRC = '/report-viewer.bundle.js';
export async function renderPdfPages(host, bytes, opts) {
  const api = await loadBundle(REPORT_VIEW_SRC, 'HUD_REPORT_VIEW');
  return api.renderPages(host, bytes, opts);
}
